<template>
  <div class="animated fadeIn report main-div">
    <vLoading v-if="vLoading" />
    <div class="pe-6 ps-6 py-10">
      <v-row dir="ltr" class="pb-2">
        <v-col class="text-sm-left text-center">
          <v-btn
            to="/admin/advancedReport"
            class="bc-primary text-white no-underline"
            elevation="0"
            width="230"
            ><span class="c-light">بازگشت به صفحه اصلی</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center fs-xlarge c-dark pt-sm-0 pt-6"
          ><span>گزارش شتاب‌دهنده</span></v-col
        >
      </v-row>
      <hr class="my-4" />
      <div class="d-lg-block d-none">
        <v-stepper v-model="stepNumber" alt-labels>
          <v-stepper-header>
            <v-stepper-step
              :complete="stepNumber > 1"
              :active-icon="'mdi-pen'"
              step="1"
            >
              <div @click="stepNumber = 1" class="text-center pointer">
                <p class="fs-xsmall mb-3">گام اول</p>
                <p class="mb-0">انتخاب شتاب‌دهنده</p>
                <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
                  <span v-if="selectedAccelerator.length">
                    ({{ selectedAccelerator.length + " شتاب‌دهنده" }})
                  </span>
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 1 ? 'completed' : ''"></v-divider>

            <v-stepper-step :complete="stepNumber > 2" step="2">
              <div
                @click="
                  stepNumber > 1 && selectedAccelerator.length
                    ? (stepNumber = 2)
                    : ''
                "
                :class="
                  stepNumber > 1 && selectedAccelerator.length ? 'pointer' : ''
                "
                class="text-center"
              >
                <p class="fs-xsmall mb-3">گام دوم</p>
                <p class="mb-0">انتخاب زمان</p>
                <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
                  <span v-if="timeType == 'all'">(گزارش تجمیعی)</span>
                  <span v-if="timeType == 'year'"
                    >(گزارش سال {{ selectedYear }})</span
                  >
                  <div v-if="timeType == 'time'">
                    ( گزارش از تاریخ
                    {{
                      selectedRange.fromYear +
                      "/" +
                      selectedRange.fromMonth +
                      "/" +
                      selectedRange.fromDay
                    }}
                    تا
                    {{
                      selectedRange.toYear +
                      "/" +
                      selectedRange.toMonth +
                      "/" +
                      selectedRange.toDay
                    }})
                  </div>
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 2 ? 'completed' : ''"></v-divider>

            <v-stepper-step step="3">
              <div class="text-center">
                <p class="fs-xsmall mb-3">گام سوم</p>
                <p class="mb-0">مشاهده و خروجی</p>
              </div>
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>
      <div class="d-lg-none d-sm-block d-none pt-4">
        <div class="d-flex flex-row justify-content-center c-grey">
          <div
            class="text-center pointer"
            @click="stepNumber = 1"
            :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
          >
            <span>انتخاب شتاب‌دهنده</span>
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              <span v-if="selectedAccelerator.length">
                ({{ selectedAccelerator.length + " شتاب‌دهنده" }})
              </span>
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div
            class="text-center"
            @click="
              stepNumber > 1 && selectedAccelerator.length
                ? (stepNumber = 2)
                : ''
            "
            :class="
              stepNumber > 1 && selectedAccelerator.length ? 'pointer' : ''
            "
          >
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >انتخاب زمان</span
            >
            <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
              <span v-if="timeType == 'all'">(گزارش تجمیعی)</span>
              <span v-if="timeType == 'year'"
                >(گزارش سال {{ selectedYear }})</span
              >
              <div v-if="timeType == 'time'">
                <p class="mb-1">
                  ( گزارش از
                  {{
                    selectedRange.fromYear +
                    "/" +
                    selectedRange.fromMonth +
                    "/" +
                    selectedRange.fromDay
                  }}
                </p>
                <p>
                  تا
                  {{
                    selectedRange.toYear +
                    "/" +
                    selectedRange.toMonth +
                    "/" +
                    selectedRange.toDay
                  }}
                  )
                </p>
              </div>
            </div>
          </div>
          <div>
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 3 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <div class="d-block d-sm-none text-center py-4">
        <div class="d-flex flex-column justify-content-center c-grey">
          <div class="text-center" @click="stepNumber = 1">
            <span :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
              >انتخاب شتاب‌دهنده</span
            >
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              <span v-if="selectedAccelerator.length">
                ({{ selectedAccelerator.length + " شتاب‌دهنده" }})
              </span>
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div
            class="text-center"
            @click="
              stepNumber > 1 && selectedAccelerator.length
                ? (stepNumber = 2)
                : ''
            "
          >
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >انتخاب زمان</span
            >
            <div v-if="stepNumber > 2" class="c-grey my-2">
              <span v-if="timeType == 'all'">(گزارش تجمیعی)</span>
              <span v-if="timeType == 'year'"
                >(گزارش سال {{ selectedYear }})</span
              >
              <div v-if="timeType == 'time'">
                <p class="mb-1">
                  ( گزارش از
                  {{
                    selectedRange.fromYear +
                    "/" +
                    selectedRange.fromMonth +
                    "/" +
                    selectedRange.fromDay
                  }}
                </p>
                <p>
                  تا
                  {{
                    selectedRange.toYear +
                    "/" +
                    selectedRange.toMonth +
                    "/" +
                    selectedRange.toDay
                  }}
                  )
                </p>
              </div>
            </div>
          </div>
          <div>
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 3 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <!-- Step 1 -->
      <div v-if="stepNumber == 1">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col class="pt-6 text-sm-right text-center">
              <span class="c-dark fs-large"
                >شتاب‌دهنده مورد نظر خود را انتخاب کنید.</span
              >
            </v-col>
            <v-col sm="6" cols="12">
              <v-text-field
                rounded
                filled
                clearable
                class="search-box mt-2 mt-sm-0"
                placeholder="نام شتاب‌دهنده را جستجو کنید..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <div v-if="!this.filter" class="mt-1 mb-5">
            <v-btn
              @click="
                !total ? selectAll('accelerator') : removeAll('accelerator')
              "
              elevation="0"
              class="all-btn"
              >{{ !total ? "همه" : "هیچ" }}</v-btn
            >
          </div>

          <div v-if="!computedAccelerators.length" class="text-center c-grey">
            <hr />
            موردی یافت نشد.
            <hr />
          </div>

          <v-row>
            <v-col
              lg="3"
              md="3"
              sm="4"
              cols="12"
              v-for="(item, index) in computedAccelerators"
              :key="index"
            >
              <div
                class="item-box"
                @click="chooseAccelerator(item)"
                :class="
                  selectedAcceleratorsIds.includes(item.id)
                    ? 'selected-box'
                    : ''
                "
              >
                {{ item.name }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Step 2 -->
      <div v-if="stepNumber == 2">
        <v-row>
          <v-col class="pt-6 text-sm-right text-center">
            <span class="c-dark fs-large"
              >زمان مورد نظر برای گرفتن گزارشات را انتخاب کنید .</span
            >
          </v-col>
        </v-row>
        <v-row class="py-8">
          <v-col md="4" sm="12" cols="12">
            <div
              @click="timeType = 'all'"
              :class="timeType == 'all' ? 'selected-box2' : ''"
              class="common-card h-100 pb-9 b-primary-bold pointer"
            >
              <div class="text-center my-10">
                <p class="fs-xlarge c-primary font-weight-bold">تجمیعی</p>
                <p class="fs-large c-grey mb-0 mt-14">
                  با انتخاب این گزینه شما قادر به دریافت گزارش تجمیعی هستید.
                </p>
              </div>
            </div>
          </v-col>
          <v-col md="4" sm="12" cols="12">
            <div
              @click="timeType != 'year' ? (showYearModal = true) : ''"
              :class="timeType == 'year' ? 'selected-box2' : 'pointer'"
              class="common-card h-100 pb-9 b-primary-bold"
            >
              <div class="text-center mt-10">
                <p class="fs-xlarge c-primary font-weight-bold">تفکیک سال</p>
                <p
                  v-if="timeType != 'year'"
                  class="fs-large c-grey mb-0 mt-14 m-10"
                >
                  پس از انتخاب این گزینه و مشخص کردن سال مورد نظر به گام بعدی
                  بروید.
                </p>
                <div v-else class="pt-5">
                  <p class="fs-large mb-10">گزارش سال {{ selectedYear }}</p>
                  <v-btn
                    @click="showYearModal = true"
                    elevation="0"
                    class="btn-radius bc-white c-primary w-100"
                    height="44"
                    ><span class="fs-medium font-weight-bold"
                      >تغییر سال</span
                    ></v-btn
                  >
                </div>
              </div>
            </div>
            <year-modal
              v-if="showYearModal"
              :chosenYear="year"
              @dialogYear="getItemYear"
              @showModal="getShowModal"
            ></year-modal>
          </v-col>
          <v-col md="4" sm="12" cols="12">
            <div
              @click="timeType != 'time' ? goToSelectRange() : ''"
              :class="timeType == 'time' ? 'selected-box2' : 'pointer'"
              class="common-card h-100 pb-9 b-primary-bold"
            >
              <div class="text-center mt-10">
                <p class="fs-xlarge c-primary font-weight-bold">
                  بازه زمانی دلخواه
                </p>
                <p v-if="timeType != 'time'" class="fs-large c-grey mb-0 mt-14">
                  پس از انتخاب این گزینه و مشخص کردن بازه زمانی مورد نظر به گام
                  بعدی بروید.
                </p>
                <div v-else class="pt-5">
                  <p class="fs-large mb-10">
                    گزارش از تاریخ
                    {{
                      selectedRange.fromYear +
                      "/" +
                      selectedRange.fromMonth +
                      "/" +
                      selectedRange.fromDay
                    }}
                    تا
                    {{
                      selectedRange.toYear +
                      "/" +
                      selectedRange.toMonth +
                      "/" +
                      selectedRange.toDay
                    }}
                  </p>
                  <v-btn
                    @click="selectTimeRangeDialog = true"
                    elevation="0"
                    class="btn-radius bc-white c-primary w-100"
                    height="44"
                    ><span class="fs-medium font-weight-bold"
                      >تغییر بازه زمانی</span
                    ></v-btn
                  >
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-dialog v-model="selectTimeRangeDialog" width="800">
          <v-card
            class="modal-card"
            style="max-height: 500px; overflow-y: auto"
          >
            <v-container class="pa-5">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <span class="fs-large c-dark pt-1"
                    >بازه زمانی مورد نظر را انتخاب کنید:</span
                  >
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="selectTimeRangeDialog = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="py-4">
                <div class="d-flex flex-sm-row flex-column">
                  <span class="fs-large c-dark pt-3 pb-sm-0 pb-4"
                    >از تاریخ:</span
                  >
                  <v-row class="ps-4 pe-0">
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          سال
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.fromYear }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          class="edit-icon pointer"
                          @click="showYearFromModal = true"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                        <year-modal
                          v-if="showYearFromModal"
                          :chosenYear="range.fromYear"
                          @dialogYear="getYearFrom"
                          @showModal="getYearFromModal"
                        ></year-modal>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          ماه
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ persianMonthName(range.fromMonth) }}
                        </div>
                        <v-spacer></v-spacer>
                        <div class="edit-icon pointer" id="datePicker2">
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          روز
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.fromDay }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          @click="
                            dateType = 'from';
                            selectDayModal = true;
                          "
                          class="edit-icon pointer"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div class="d-flex flex-sm-row flex-column mt-8">
                  <span class="fs-large c-dark pt-3 pb-sm-0 pb-4"
                    >تا تاریخ:</span
                  >
                  <v-row class="ps-4 pe-0">
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          سال
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.toYear }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          class="edit-icon pointer"
                          @click="showYearToModal = true"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                        <year-modal
                          v-if="showYearToModal"
                          :chosenYear="range.toYear"
                          @dialogYear="getYearTo"
                          @showModal="getYearToModal"
                        ></year-modal>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          ماه
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ persianMonthName(range.toMonth) }}
                        </div>
                        <v-spacer></v-spacer>
                        <div class="edit-icon pointer" id="datePicker4">
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          روز
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.toDay }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          @click="
                            dateType = 'to';
                            selectDayModal = true;
                          "
                          class="edit-icon pointer"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <date-picker
                element="datePicker2"
                v-model="range.fromMonth"
                @change="
                  getNumberOfDays('from');
                  changeDate('month');
                "
                type="month"
                :auto-submit="true"
              >
              </date-picker>
              <date-picker
                element="datePicker4"
                v-model="range.toMonth"
                @change="getNumberOfDays('to')"
                type="month"
                :auto-submit="true"
                :min="range.fromYear == range.toYear ? range.fromMonth : ''"
              >
              </date-picker>
              <div class="pt-4 text-right">
                <v-btn
                  class="bc-primary btn-radius c-light"
                  width="100"
                  height="47"
                  @click="
                    selectedRange = JSON.parse(JSON.stringify(range));
                    selectTimeRangeDialog = false;
                    timeType = 'time';
                  "
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="selectDayModal" width="300">
          <v-card class="modal-card pa-0">
            <div v-if="dateType == 'from'">
              <v-card-title class="bc-primary py-4">
                <span
                  class="mx-auto c-light text-center"
                  style="font-size: 2rem"
                  >{{ range.fromDay }}</span
                >
              </v-card-title>
              <div class="fit-content pa-5">
                <div
                  v-for="(number, index) in fromNumberOfDay"
                  :key="index"
                  class="day-box d-inline-block pointer"
                  :class="parseInt(range.fromDay) == number ? 'selected' : ''"
                  @click="
                    selectDayModal = false;
                    range.fromDay = number;
                  "
                >
                  {{ number }}
                </div>
              </div>
            </div>
            <div v-else>
              <v-card-title class="bc-primary py-4">
                <span
                  class="mx-auto c-light text-center"
                  style="font-size: 2rem"
                  >{{ range.toDay }}</span
                >
              </v-card-title>
              <div class="fit-content pa-5">
                <div
                  v-for="(number, index) in toNumberOfDay"
                  :key="index"
                  class="day-box d-inline-block"
                  :class="parseInt(range.toDay) == number ? 'selected' : ''"
                >
                  <div
                    v-if="
                      range.fromYear == range.toYear &&
                      range.fromMonth == range.toMonth
                    "
                  >
                    <div
                      class="pointer"
                      @click="
                        selectDayModal = false;
                        range.toDay = number;
                      "
                      v-if="index >= parseInt(range.fromDay) - 1"
                    >
                      {{ number }}
                    </div>
                    <div v-else class="disabled">
                      {{ number }}
                    </div>
                  </div>
                  <div
                    class="pointer"
                    @click="
                      selectDayModal = false;
                      range.toDay = number;
                    "
                    v-else
                  >
                    {{ number }}
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>

      <!-- Step 3 -->
      <div v-if="stepNumber == 3" class="pb-6">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col
              v-if="selectedAccelerator.length"
              class="pt-6 text-sm-right text-center"
            >
              <v-btn
                @click="selectedAcceleratorsDialog = true"
                class="secondary-btn"
              >
                <span class="fs-medium">
                  {{ selectedAccelerator.length }} شتاب‌دهنده</span
                >
              </v-btn>
            </v-col>
            <v-spacer class="d-none d-sm-block"></v-spacer>
            <v-col cols="" class="pt-6 text-sm-left text-center">
              <v-btn
                class="bc-primary text-white btn-radius"
                width="200"
                height="47"
                elevation="0"
                @click="saveDocx('doc')"
              >
                <span class="fs-small">
                  خروجی ورد

                  <v-icon>$Word</v-icon></span
                >
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-tabs v-model="tab">
                <v-tab class="c-primary" v-if="deviceType == 'desktop'"
                  >نمودار‌ها</v-tab
                >
                <v-tab class="c-primary">جدول‌ها</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <!-- نمودار‌ها -->

                <v-tab-item v-if="deviceType == 'desktop'">
                  <v-container class="pe-10 ps-10 pt-12">
                    <div class="text-center" v-if="computedCharts">
                      <hr />
                      موردی برای نمایش وجود ندارد.
                      <hr />
                    </div>
                    <div v-if="deviceType == 'desktop'">
                      <div class="mb-16">
                        <div
                          v-if="allData.barChartHasData"
                          id="capture1"
                          class="pa-6"
                        >
                          <span v-show="false">{{ reactivity }}</span>
                          <v-row>
                            <v-col sm="6" cols="12"
                              ><h5 class="fs-xlarge">
                                نمودار ستونی فراوانی حمایت‌ها به تفکیک حوزه
                              </h5></v-col
                            >
                            <v-spacer></v-spacer>
                            <v-col class="text-left" sm="6" cols="12">
                              <v-btn
                                class="bc-primary text-white btn-radius"
                                width="200"
                                height="47"
                                elevation="0"
                                @click="
                                  capture(
                                    'capture1',
                                    'نمودار-ستونی-فراوانی-حمایت-ها-به-تفکیک-حوزه-ها',
                                    0
                                  )
                                "
                                :loading="gettingPic[0]"
                                data-html2canvas-ignore
                              >
                                <template v-slot:loader>
                                  <span
                                    class="white--text fs-xsmall d-flex flex-row"
                                  >
                                    <span
                                      ><v-icon class="white--text"
                                        >mdi-timer-sand-empty</v-icon
                                      >
                                      چند لحظه صبر کنید...
                                    </span>
                                  </span>
                                </template>
                                <span class="fs-small">
                                  خروجی عکس

                                  <v-icon>$Camera</v-icon></span
                                >
                              </v-btn>
                              <a id="download"></a>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col v-if="barBusy" class="text-center">
                              <v-progress-circular
                                indeterminate
                                color="#068D9D"
                                class="align-middle button-td"
                              ></v-progress-circular>
                            </v-col>
                            <v-col v-else>
                              <Chart
                                name="barChart"
                                :chartdata="dataBar1"
                                :options="optionsBar1"
                                type="bar"
                                :height="deviceType != 'mobile' ? '200' : '400'"
                                v-if="barLoaded"
                              ></Chart>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <div class="mb-16">
                        <div
                          v-if="allData.uniBarChartHasData"
                          id="capture2"
                          class="pa-6"
                        >
                          <v-row>
                            <v-col sm="6" cols="12"
                              ><h5 class="fs-xlarge">
                                نمودار ستونی فراوانی حمایت‌ها به تفکیک دانشگاه
                              </h5></v-col
                            >
                            <v-spacer></v-spacer>
                            <v-col class="text-left" sm="6" cols="12">
                              <v-btn
                                class="bc-primary text-white btn-radius"
                                width="200"
                                height="47"
                                elevation="0"
                                @click="
                                  capture(
                                    'capture2',
                                    'نمودار-ستونی-فراوانی-حمایت-ها-به-تفکیک-دانشگاه‌-ها',
                                    1
                                  )
                                "
                                :loading="gettingPic[1]"
                                data-html2canvas-ignore
                              >
                                <template v-slot:loader>
                                  <span
                                    class="white--text fs-xsmall d-flex flex-row"
                                  >
                                    <span
                                      ><v-icon class="white--text"
                                        >mdi-timer-sand-empty</v-icon
                                      >
                                      چند لحظه صبر کنید...
                                    </span>
                                  </span>
                                </template>
                                <span class="fs-small">
                                  خروجی عکس

                                  <v-icon>$Camera</v-icon></span
                                >
                              </v-btn></v-col
                            >
                          </v-row>
                          <v-row>
                            <v-col v-if="barBusy" class="text-center">
                              <v-progress-circular
                                indeterminate
                                color="#068D9D"
                                class="align-middle button-td"
                              ></v-progress-circular>
                            </v-col>
                            <v-col v-else>
                              <Chart
                                name="barChart3"
                                :chartdata="dataBar2"
                                :options="optionsBar1"
                                type="bar"
                                :height="deviceType != 'mobile' ? '200' : '400'"
                                v-if="barLoaded"
                              ></Chart>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <div>
                        <div
                          v-if="allData.yearBarChartHasData"
                          id="capture3"
                          class="pa-6"
                        >
                          <v-row>
                            <v-col sm="6" cols="12"
                              ><h5 class="fs-xlarge">
                                نمودار ستونی فراوانی حمایت‌ها به تفکیک سال‌
                              </h5></v-col
                            >
                            <v-spacer></v-spacer>
                            <v-col class="text-left" sm="6" cols="12">
                              <v-btn
                                class="bc-primary text-white btn-radius"
                                width="200"
                                height="47"
                                elevation="0"
                                @click="
                                  capture(
                                    'capture3',
                                    'نمودار-ستونی-فراوانی-حمایت-ها-به-تفکیک-سال‌-ها',
                                    2
                                  )
                                "
                                :loading="gettingPic[2]"
                                data-html2canvas-ignore
                              >
                                <template v-slot:loader>
                                  <span
                                    class="white--text fs-xsmall d-flex flex-row"
                                  >
                                    <span
                                      ><v-icon class="white--text"
                                        >mdi-timer-sand-empty</v-icon
                                      >
                                      چند لحظه صبر کنید...
                                    </span>
                                  </span>
                                </template>
                                <span class="fs-small">
                                  خروجی عکس

                                  <v-icon>$Camera</v-icon></span
                                >
                              </v-btn></v-col
                            >
                          </v-row>
                          <v-row>
                            <v-col v-if="barBusy" class="text-center">
                              <v-progress-circular
                                indeterminate
                                color="#068D9D"
                                class="align-middle button-td"
                              ></v-progress-circular>
                            </v-col>
                            <v-col v-else>
                              <Chart
                                name="barChart4"
                                :chartdata="dataBar3"
                                :options="optionsBar1"
                                type="bar"
                                :height="deviceType != 'mobile' ? '200' : '400'"
                                v-if="barLoaded"
                              ></Chart>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </div>
                  </v-container>
                </v-tab-item>

                <!-- جدول‌ها -->
                <v-tab-item>
                  <div class="main-table" v-if="deviceType == 'mobile'">
                    <h4 class="mt-6 text-sm-right text-center">
                      جدول فراوانی حمایت‌ها به تفکیک حوزه
                    </h4>
                    <div class="text-sm-left text-center">
                      <v-btn
                        class="bc-primary text-white btn-radius mt-5 mb-10"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="$refs.table1.$el.click()"
                      >
                        <span class="fs-small">
                          خروجی اکسل

                          <v-icon>$Excel</v-icon></span
                        >
                      </v-btn>
                      <vue-excel-xlsx
                        v-show="false"
                        ref="table1"
                        :data="tableData1"
                        :columns="excelBarFields"
                        :filename="'جدول فراوانی حمایت‌ها به تفکیک حوزه'"
                        :sheetname="currentDate"
                      >
                        دریافت اکسل
                      </vue-excel-xlsx>
                    </div>
                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="tableData1"
                      :fields="barFields"
                      :current-page="barCurrentPage1"
                      :per-page="perPage"
                      :filter="filter"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (barCurrentPage1 - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="barTotalRows1">
                      <v-col>
                        <v-pagination
                          v-model="barCurrentPage1"
                          :length="Math.ceil(barTotalRows1 / perPage)"
                          :total-visible="4"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>

                    <h4 class="mt-15 text-sm-right text-center">
                      جدول فراوانی حمایت‌ها به تفکیک دانشگاه
                    </h4>
                    <div class="text-sm-left text-center">
                      <v-btn
                        class="bc-primary text-white btn-radius mt-5 mb-10"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="$refs.table2.$el.click()"
                      >
                        <span class="fs-small">
                          خروجی اکسل

                          <v-icon>$Excel</v-icon></span
                        >
                      </v-btn>
                      <vue-excel-xlsx
                        v-show="false"
                        ref="table2"
                        :data="tableData2"
                        :columns="excelBarFields"
                        :filename="'جدول-فراوانی-دانشگاه‌ها'"
                        :sheetname="currentDate"
                      >
                        دریافت اکسل
                      </vue-excel-xlsx>
                    </div>
                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="tableData2"
                      :fields="barFields"
                      :current-page="barCurrentPage2"
                      :per-page="perPage"
                      :filter="filter"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (barCurrentPage2 - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="barTotalRows2">
                      <v-col>
                        <v-pagination
                          v-model="barCurrentPage2"
                          :length="Math.ceil(barTotalRows2 / perPage)"
                          :total-visible="4"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                    <h4 class="mt-15 text-sm-right text-center">
                      جدول فراوانی حمایت‌ها به تفکیک سال‌
                    </h4>
                    <div class="text-sm-left text-center">
                      <v-btn
                        class="bc-primary text-white btn-radius mt-5 mb-10"
                        width="200"
                        height="47"
                        elevation="0"
                        @click="$refs.table3.$el.click()"
                      >
                        <span class="fs-small">
                          خروجی اکسل

                          <v-icon>$Excel</v-icon></span
                        >
                      </v-btn>
                      <vue-excel-xlsx
                        v-show="false"
                        ref="table3"
                        :data="tableData3"
                        :columns="excelBarFields2"
                        :filename="'جدول-فراوانی-سال‌ها'"
                        :sheetname="currentDate"
                      >
                        دریافت اکسل
                      </vue-excel-xlsx>
                    </div>
                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="tableData3"
                      :fields="barFields2"
                      :current-page="barCurrentPage3"
                      :per-page="perPage"
                      :filter="filter"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (barCurrentPage1 - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="barTotalRows3">
                      <v-col>
                        <v-pagination
                          v-model="barCurrentPage3"
                          :length="Math.ceil(barTotalRows3 / perPage)"
                          :total-visible="4"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                  </div>
                  <!-- inja -->
                  <div class="main-table">
                    <v-row>
                      <v-col md="6" cols="12">
                        <h5
                          class="mt-6 fs-xlarge text-sm-right text-center pt-3"
                        >
                          جدول حمایت‌های انجام شده به تفکیک سال
                        </h5>
                      </v-col>
                      <v-col md="6" cols="12">
                        <div class="text-sm-left text-center">
                          <v-btn
                            class="bc-primary text-white btn-radius my-10"
                            width="200"
                            height="47"
                            elevation="0"
                            @click="$refs.table4.$el.click()"
                          >
                            <span class="fs-small">
                              خروجی اکسل

                              <v-icon>$Excel</v-icon></span
                            >
                          </v-btn>
                          <vue-excel-xlsx
                            v-show="false"
                            ref="table4"
                            :data="items"
                            :columns="excelFields"
                            :filename="'جدول حمایت‌های انجام شده به تفکیک سال'"
                            :sheetname="currentDate"
                          >
                            دریافت اکسل
                          </vue-excel-xlsx>
                        </div>
                      </v-col>
                    </v-row>

                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="items"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :busy="tableBusy"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (currentPage - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="totalRows">
                      <v-col>
                        <v-pagination
                          v-model="currentPage"
                          :length="Math.ceil(totalRows / perPage2)"
                          :total-visible="5"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>

                    <div class="mt-12">
                      <v-expansion-panels accordion>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >طرح های پیشنهادی فناورانه حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items1"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items1"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items1 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >طرح های پسادکتری حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items2"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items2"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items2 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >رساله های دکتری حمایت شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items3"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items3"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items3 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >پایان نامه های کارشناسی ارشد حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items4"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items4"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items4 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >فرصت‌های مطالعاتی حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items5"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items5"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items5 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >نشست‌های استانی حمایت شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items6"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items6"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items6 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >مقالات زیست فناوری حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items7"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items7"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items7 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >نخبگان وظیفه حمایت شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items8"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items8"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items8 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
          <v-dialog v-model="selectedAcceleratorsDialog" width="600">
            <v-card class="modal-card">
              <v-container class="pa-5">
                <v-row class="mb-1">
                  <v-col class="text-right">
                    <span class="fs-large c-dark pt-1"
                      >شتاب‌دهنده‌های انتخاب شده:</span
                    >
                  </v-col>
                  <v-col class="text-left">
                    <span @click="selectedAcceleratorsDialog = false">
                      <v-icon class="pointer">$Close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div style="max-height: 400px; overflow-y: auto">
                  <div
                    v-for="(item, index) in selectedAccelerator"
                    :key="index"
                    class="my-4 fs-medium c-grey d-flex flex-row"
                  >
                    <div class="small-logoBox">
                      <img src="/companyLogo.png" alt="" />
                    </div>
                    <div class="pa-4">
                      {{ item }}
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <v-row v-if="!pageLoading" class="mt-8 w-100">
        <v-col
          class="text-right pe-0 ps-0"
          v-if="stepNumber < 3"
          md="4"
          sm="6"
          cols="12"
        >
          <v-btn
            class="bc-primary text-white no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="nextStep()"
            :disabled="computedNextButton"
            >گام بعدی</v-btn
          >
        </v-col>
        <v-spacer v-if="stepNumber < 3"></v-spacer>
        <v-col class="text-left pe-0 ps-0" md="4" sm="6" cols="12">
          <v-btn
            class="b-primary bc-white c-primary no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="previousStep()"
            v-if="stepNumber > 1"
            >گام قبلی</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div class="goToDown" @click="goDown()">
      <v-icon>mdi-chevron-down</v-icon>
    </div>
    <!-- docx -->
    <div v-show="false" id="doc">
      <div style="direction: rtl">
        <h3 class="mt-10">جدول فراوانی حمایت‌ها به تفکیک حوزه</h3>
        <div v-if="tableData1.length">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="tableData1"
            :fields="barFields"
            :current-page="barCurrentPage1"
            :per-page="perPage"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (barCurrentPage1 - 1) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->

        <h3 class="mt-10">جدول فراوانی حمایت‌ها به تفکیک دانشگاه</h3>
        <div v-if="tableData2.length">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="tableData2"
            :fields="barFields"
            :current-page="barCurrentPage2"
            :per-page="perPage"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (barCurrentPage2 - 1) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <h3 class="mt-10">جدول فراوانی حمایت‌ها به تفکیک سال‌</h3>
        <div v-if="tableData3.length">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="tableData3"
            :fields="barFields2"
            :current-page="barCurrentPage3"
            :per-page="perPage"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (barCurrentPage1 - 1) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <h3 class="mt-10">جدول حمایت‌های انجام شده به تفکیک سال</h3>
        <div v-if="items.length">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="items"
            :fields="fields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items1.length">
          <h3 class="mt-10">طرح های پیشنهادی فناورانه حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items1"
            :fields="projectFields"
            :filter="filter"
            head-variant="light"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items2.length">
          <h3 class="mt-10">طرح های پسادکتری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items2"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items3.length">
          <h3 class="mt-10">رساله های دکتری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items3"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items4.length">
          <h3 class="mt-10">پایان نامه‌های کارشناسی ارشد</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items4"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items5.length">
          <h3 class="mt-10">فرصت‌های مطالعاتی حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items5"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items6.length">
          <h3 class="mt-10">نشست‌های استانی حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items6"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items7.length">
          <h3 class="mt-10">مقالات زیست فناوری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items7"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items8.length">
          <h3 class="mt-10">نخبگان وظیفه حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items8"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import screenShot from "../../../mixins/screenShot";
import Chart from "../../../components/charts/Chart.vue";
import YearModal from "@/components/YearModal";
//import { set } from "vue/types/umd";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Chart,
    YearModal,
  },
  mixins: [screenShot],
  data() {
    return {
      filter: "",
      vLoading: false,
      accelerators: [],
      isSelected: false,
      selectedAccelerator: [],
      selectedAcceleratorsIds: [],
      total: false,
      stepNumber: 1,
      projects: {
        items1: [],
        items2: [],
        items3: [],
        items4: [],
        items5: [],
        items6: [],
        items7: [],
        items8: [],
      },
      timeType: "",
      selectYearDialog: false,
      selectTimeRangeDialog: false,
      selectedAcceleratorsDialog: false,
      selectDayModal: false,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      year: moment(new Date()).format("jYYYY"),
      selectedYear: "",
      currentYear: moment(new Date()).format("jYYYY"),
      range: {
        fromYear: parseInt(moment(new Date()).format("jYYYY")) - 1,
        fromMonth: moment(new Date()).format("jMM"),
        fromDay: moment(new Date()).format("jDD"),
        toYear: moment(new Date()).format("jYYYY"),
        toMonth: moment(new Date()).format("jMM"),
        toDay: moment(new Date()).format("jDD"),
      },
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      items: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      barCurrentPage1: 1,
      barTotalRows1: "",
      barCurrentPage2: 1,
      barTotalRows2: "",
      barCurrentPage3: 1,
      barTotalRows3: "",
      barFields: [
        // { key: "index", label: "#" },
        { key: "name", label: "عنوان" },
        { key: "data", label: "تعداد" },
        { key: "data2", label: "تعداد کل" },
      ],
      excelBarFields: [
        { field: "name", label: "عنوان" },
        { field: "data", label: "تعداد" },
        { field: "data2", label: "تعداد کل" },
      ],
      barFields2: [
        // { key: "index", label: "#" },
        { key: "name", label: "سال" },
        { key: "data", label: "تعداد" },
        { key: "data2", label: "تعداد کل" },
      ],
      excelBarFields2: [
        // { key: "index", label: "#" },
        { field: "name", label: "سال" },
        { field: "data", label: "تعداد" },
        { field: "data2", label: "تعداد کل" },
      ],
      fields: [
        { key: "year", label: "سال" },
        { key: "project", label: "طرح تحقیقاتی" },
        { key: "opportune", label: "فرصت مطالعاتی" },
        { key: "phd", label: "رساله دکتری" },
        { key: "meeting", label: "نشست تخصصی" },
        { key: "master", label: "پایان نامه ارشد" },
        { key: "postDoc", label: "دوره پسادکتری" },
        { key: "article", label: "مقاله ISI" },
        { key: "elite", label: "نخبه وظیفه" },
      ],
      excelFields: [
        { field: "year", label: "سال" },
        { field: "project", label: "طرح تحقیقاتی" },
        { field: "opportune", label: "فرصت مطالعاتی" },
        { field: "phd", label: "رساله دکتری" },
        { field: "meeting", label: "نشست تخصصی" },
        { field: "master", label: "پایان نامه ارشد" },
        { field: "postDoc", label: "دوره پسادکتری" },
        { field: "article", label: "مقاله ISI" },
        { field: "elite", label: "نخبه وظیفه" },
      ],
      project1: [],
      projectFields: [
        // { key: "index", label: "#" },
        { key: "faSubject", label: "عنوان طرح" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "finalDate", label: "تاریخ پایان" },
        { key: "progress", label: "درصد پیشرفت" },
        // { key: "companyName", label: "نام شرکت دانش بنیان" },
        { key: "zones", label: "حوزه فعالیت" },
        { key: "mehvar", label: "محور تقسیم کار ملی" },
        { key: "observer", label: "نام ناظر طرح" },
      ],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      barCurrentPage: 1,
      barTotalRows: "",
      pieCurrentPage: 1,
      pieTotalRows: "",
      currentPage2: 1,
      projectCurrentPage: 1,
      totalRows2: "",
      projectTotalRows: {
        items1: null,
        items2: null,
        items3: null,
        items4: null,
        items5: null,
        items6: null,
        items7: null,
        items8: null,
      },
      perPage2: 10,
      tableBusy: false,
      items1: [],
      items2: [],
      selectedRange: {},
      fromNumberOfDay: null,
      toNumberOfDay: null,
      dateType: "",
      tab: null,
      barBusy: false,
      doughnutBusy: false,
      barLoaded: false,
      dataBar1: {
        labels: [],
        datasets: [],
      },
      dataBar2: {
        labels: [],
        datasets: [],
      },
      dataBar3: {
        labels: [],
        datasets: [],
      },
      optionsBar1: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
            position: "top",
            align: "start",
            rtl: true,
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
              filter: function (item) {
                // Logic to remove a particular legend item goes here
                return item.text != "";
              },
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              font: { family: "iransans" },
            },
          },
          x: {
            ticks: {
              barThickness: 45,
              barPercentage: 1.0,
              categoryPercentage: 0.8,
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      dataPie: {
        labels: [],
        datasets: [],
      },
      optionsBar2: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: 40,
        plugins: {
          legend: {
            display: false,
            position: "left",
            fontSize: 16,
            rtl: true,
            labels: {
              font: {
                family: "iransans",
                size: 16,
              },
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },
      },
      deviceType: "",
      pageLoading: false,
      reactivity: true,
      allData: {},
      barTable: [],
      pieTable: [],
      showYearModal: false,
      showYearFromModal: false,
      showYearToModal: false,
    };
  },
  methods: {
    getItemYear(value) {
      this.year = value;
      this.selectedYear = this.year;
      this.timeType = "year";
    },
    getShowModal(value) {
      this.showYearModal = value;
    },
    getYearFrom(value) {
      this.range.fromYear = value;
    },
    getYearFromModal(value) {
      this.showYearFromModal = value;
      this.getNumberOfDays("from");
    },
    getYearTo(value) {
      this.range.toYear = value;
    },
    getYearToModal(value) {
      this.showYearToModal = value;
      this.getNumberOfDays("to");
    },
    persianMonthName(month) {
      let monthName;
      monthName = this.monthsName[Number(month) - 1];
      return monthName;
    },
    // getLogo(item) {
    //   if (this.university.filter((x) => x.id == item)) {
    //     return this.university.filter((x) => x.id == item)[0].url;
    //   } else return "";
    // },
    goDown() {
      var container = document.querySelector("html");
      var scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = "گزارش-شتاب-دهنده.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    chooseAccelerator(item) {
      if (
        this.selectedAccelerator.length &&
        this.selectedAccelerator.includes(item.name)
      ) {
        let index;
        index = this.selectedAccelerator.indexOf(item.name);
        this.selectedAccelerator.splice(index, 1);
        this.selectedAcceleratorsIds.splice(index, 1);
      } else {
        this.selectedAccelerator.push(item.name);
        this.selectedAcceleratorsIds.push(item.id);
      }

      if (this.selectedAccelerator.length == this.accelerators.length) {
        this.total = true;
      } else {
        this.total = false;
      }
    },
    selectAll(type) {
      if (type == "accelerator") {
        this.accelerators.forEach((x) => {
          if (!this.selectedAccelerator.includes(x.name)) {
            this.selectedAccelerator.push(x.name);
            this.selectedAcceleratorsIds.push(x.id);
          }
        });
        this.total = true;
      }
      this.goDown();
    },
    removeAll(type) {
      if (type == "accelerator") {
        this.selectedAccelerator = [];
        this.selectedAcceleratorsIds = [];
        this.total = false;
      }
    },
    nextStep() {
      this.filter = "";
      ++this.stepNumber;
      if (this.stepNumber == 3) {
        this.tab = 0;

        this.getReportInfo();
      }

      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    previousStep() {
      this.filter = "";
      if (this.stepNumber == 3 && !this.selectedAccelerator.length) {
        this.stepNumber = 1;
      } else {
        --this.stepNumber;
      }

      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },

    getAccelerator() {
      this.pageLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    goToSelectRange() {
      this.selectTimeRangeDialog = true;
      this.getNumberOfDays("from");
      this.getNumberOfDays("to");
    },
    changeDate(type) {
      if (type == "year") {
        if (this.range.fromYear > this.range.toYear) {
          this.range.toYear = this.range.fromYear;
        }
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth > this.range.toMonth) {
            this.range.toMonth = this.range.fromMonth;
          }
        }
        if (
          this.range.fromYear == this.range.toYear &&
          this.range.fromMonth == this.range.toMonth
        ) {
          if (this.range.fromDay > this.range.toDay) {
            this.range.toDay = this.range.fromDay;
          }
        }
      }
      if (type == "month") {
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth > this.range.toMonth) {
            this.range.toMonth = this.range.fromMonth;
          }
          if (this.range.fromMonth == this.range.toMonth) {
            if (this.range.fromDay > this.range.toDay) {
              this.range.toDay = this.range.fromDay;
            }
          }
        }
      }
      if (type == "day") {
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth == this.range.toMonth) {
            if (this.range.fromDay > this.range.toDay) {
              this.range.toDay = this.range.fromDay;
            }
          }
        }
      }
    },
    getNumberOfDays(type) {
      if (type == "from") {
        if (1 <= parseInt(this.range.fromMonth) < 7) {
          this.fromNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.fromMonth) &&
          parseInt(this.range.fromMonth) != 12
        ) {
          this.fromNumberOfDay = 30;
        }
        if (parseInt(this.range.fromMonth) == 12) {
          let isLead = moment(
            this.range.fromYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.fromNumberOfDay = 30;
          } else this.fromNumberOfDay = 29;
        }

        if (parseInt(this.range.fromDay) > parseInt(this.fromNumberOfDay)) {
          this.range.fromDay = this.fromNumberOfDay;
        }
      } else {
        if (1 <= parseInt(this.range.toMonth) < 7) {
          this.toNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.toMonth) &&
          parseInt(this.range.toMonth) != 12
        ) {
          this.toNumberOfDay = 30;
        }
        if (parseInt(this.range.toMonth) == 12) {
          let isLead = moment(
            this.range.toYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.toNumberOfDay = 30;
          } else this.toNumberOfDay = 29;
        }

        if (parseInt(this.range.toDay) > parseInt(this.toNumberOfDay)) {
          this.range.toDay = this.toNumberOfDay;
        }
      }
    },
    getReportInfo() {
      this.pageLoading = true;
      this.barBusy = true;
      this.doughnutBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/accelerators/getReport",
          {
            acceleratorIds: this.selectedAcceleratorsIds,
            reportType: this.timeType,
            year: this.timeType == "year" ? this.year : "",
            startDate:
              this.timeType == "time"
                ? this.range.fromYear +
                  "/" +
                  this.range.fromMonth +
                  "/" +
                  this.range.fromDay
                : "",
            endDate:
              this.timeType == "time"
                ? this.range.toYear +
                  "/" +
                  this.range.toMonth +
                  "/" +
                  this.range.toDay
                : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.allData = res.data;
            this.dataBar1 = res.data.barChart;
            this.dataBar2 = res.data.uniBarChart;
            this.dataBar3 = res.data.yearBarChart;
            for (let i = 1; i < 4; i++) {
              this["dataBar" + i].datasets[0].barPercentage = 0.8;
              this["dataBar" + i].datasets[0].borderRadius = 5;
              this["dataBar" + i].datasets[1].barPercentage = 0.8;
              this["dataBar" + i].datasets[1].borderRadius = 5;
            }
            this.barBusy = false;
            this.doughnutBusy = false;
            this.tableData1 = this.dataBar1.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataBar1.datasets[0].data[index],
                data2: this.dataBar1.datasets[1].data[index],
              };
            });
            this.barTotalRows1 = this.tableData1.length;
            this.tableData2 = this.dataBar2.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataBar2.datasets[0].data[index],
                data2: this.dataBar2.datasets[1].data[index],
              };
            });
            this.barTotalRows2 = this.tableData2.length;
            this.tableData3 = this.dataBar3.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataBar3.datasets[0].data[index],
                data2: this.dataBar3.datasets[1].data[index],
              };
            });
            this.barTotalRows3 = this.tableData3.length;

            this.items = res.data.yearTable;
            this.totalRows = this.items.length;
            this.projects.items1 = res.data.project;
            this.projects.items2 = res.data.postDoc;
            this.projects.items3 = res.data.phd;
            this.projects.items4 = res.data.master;
            this.projects.items5 = res.data.opportune;
            this.projects.items6 = res.data.meeting;
            this.projects.items7 = res.data.article;
            this.projects.items8 = res.data.elite;

            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar2.plugins.legend.labels.font.size = "10";
              this.optionsBar2.plugins.legend.position = "top";
            }
            setTimeout(() => {
              this.barLoaded = true;
              this.barLoaded3 = true;
              this.pageLoading = false;
            }, 1000);
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    computedAccelerators() {
      if (this.filter) {
        let filtered;
        filtered = this.accelerators.filter((x) =>
          x.name.includes(this.filter)
        );
        return filtered;
      } else {
        return this.accelerators;
      }
    },
    computedNextButton() {
      if (this.stepNumber == 1) {
        if (!this.selectedAccelerator.length) {
          return true;
        } else return false;
      }
      if (this.stepNumber == 2) {
        if (!this.timeType) {
          return true;
        } else return false;
      }
    },
    computedCharts() {
      if (!this.allData.barChartHasData && !this.allData.pieChartHasData) {
        return true;
      } else return false;
    },
  },
  mounted() {
    if (window.screen.width < 500) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 500) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.gettingPic = [false, false, false];
    this.getAccelerator();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  .edit-icon {
    path {
      stroke: #068d9d !important;
    }
    transform: translateY(-2px);
  }
  .v-card__title {
    border-radius: 10px 10px 0 0;
  }
  .day-box {
    width: 37px;
    height: 37px;
    text-align: center;
    border-radius: 50%;
    padding-top: 8px;
    color: #656a81;
    &:hover {
      background-color: #eeeeee;
    }
    &.selected {
      background-color: #e6e6e6;
      color: #068d9d;
      font-weight: bold;
    }
  }
  .small-logoBox {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
button {
  outline: none !important;
}
</style>
